import { baseApi } from './baseApi';

export const bomApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getBoms: builder.query({
      query: (params) => ({
        url: '/boms',
        params,
      }),
      providesTags: ['BOM'],
    }),
    getBom: builder.query({
      query: (id) => `/boms/${id}`,
      providesTags: (result, error, id) => [{ type: 'BOM', id }],
    }),
    createBom: builder.mutation({
      query: (data) => ({
        url: '/boms',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['BOM'],
    }),
    updateBom: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/boms/${id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [{ type: 'BOM', id }, 'BOM'],
    }),
    deleteBom: builder.mutation({
      query: (id) => ({
        url: `/boms/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['BOM'],
    }),
  }),
});

export const {
  useGetBomsQuery,
  useGetBomQuery,
  useCreateBomMutation,
  useUpdateBomMutation,
  useDeleteBomMutation,
} = bomApi;
